import { render } from "./LabStageView.vue?vue&type=template&id=6edea25b"
import script from "./LabStageView.vue?vue&type=script&lang=js"
export * from "./LabStageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__